export const ONBOARDING_FORM_LOCALSTORAGE_KEY = 'onboarding-form'
export const ONBOARDING_STEPPER_LOCALSTORAGE_KEY = 'onboarding-stepper-value'
export const MAIN_NAV_MENU_LOCALSTORAGE_KEY = 'main-nav-menu'
